/* ============================================
   HAEZEL TECH | Mobile Device Model Dropdown
   Version: 6.0
   v5.0: tap an identity pill and go straight to results
   v5.1: filter headings always open and close, even after
         a filter has been applied
   v6.0: grouped dropdown (iPhone, Samsung Galaxy, Laptop
         sleeves, AirPods), newest first, "All models" by
         default, clear sleeve labels on mobile and desktop
============================================ */

(function() {
  'use strict';

  var SIZE_PARAM = 'filter.v.option.size';

  function groupOf(val) {
    var v = (val || '').toLowerCase();
    if (v.indexOf('iphone') !== -1) return 'iphone';
    if (v.indexOf('samsung') !== -1 || v.indexOf('galaxy') !== -1) return 'samsung';
    if (v.indexOf('airpods') !== -1) return 'airpods';
    if (/^\d+(\.\d+)?\s*(″|"|”|in\b|inch)/.test(v)) return 'sleeve';
    return 'other';
  }

  function labelOf(val) {
    return groupOf(val) === 'sleeve' ? 'Laptop sleeve ' + val : val;
  }

  function rankOf(val) {
    var g = groupOf(val);
    var m, n, s = 0;
    if (g === 'iphone') {
      m = val.match(/iphone\s*(\d+)/i);
      n = m ? parseInt(m[1], 10) : 0;
      if (/pro max/i.test(val)) s = 5;
      else if (/pro/i.test(val)) s = 4;
      else if (/air|duo/i.test(val)) s = 3;
      else if (/plus/i.test(val)) s = 2;
      else s = 1;
      return n * 10 + s;
    }
    if (g === 'samsung') {
      m = val.match(/s\s*(\d+)/i);
      n = m ? parseInt(m[1], 10) : 0;
      if (/ultra/i.test(val)) s = 4;
      else if (/plus|\+/i.test(val)) s = 3;
      else if (/fe\b/i.test(val)) s = 1;
      else s = 2;
      return n * 10 + s;
    }
    if (g === 'sleeve') {
      // 13″ before 15″
      return -parseFloat(val);
    }
    return 0;
  }

  var GROUPS = [
    { key: 'iphone',  label: 'iPhone' },
    { key: 'samsung', label: 'Samsung Galaxy' },
    { key: 'sleeve',  label: 'Laptop sleeves' },
    { key: 'airpods', label: 'AirPods' },
    { key: 'other',   label: 'Other' }
  ];

  function isSizeInput(cb) {
    return cb && cb.name === SIZE_PARAM;
  }

  function buildDeviceDropdown() {
    var filterForm = document.getElementById('FacetFiltersFormMobile');
    if (!filterForm) return;
    if (filterForm.querySelector('.ht-filter-dropdown-row')) return;

    var allDetails = filterForm.querySelectorAll('.mobile-facets__details');
    if (!allDetails.length) return;

    var deviceDetail = null;
    allDetails.forEach(function(detail) {
      if (deviceDetail) return;
      var cbs = detail.querySelectorAll('input[type="checkbox"]');
      for (var i = 0; i < cbs.length; i++) {
        if (isSizeInput(cbs[i]) || groupOf(cbs[i].value) !== 'other') { deviceDetail = detail; break; }
      }
    });

    if (!deviceDetail) return;

    var checkboxes = deviceDetail.querySelectorAll('input[type="checkbox"]');
    if (!checkboxes.length) return;

    var urlParams = new URLSearchParams(window.location.search);
    var activeFilter = urlParams.get(SIZE_PARAM) || '';

    var buckets = {};
    checkboxes.forEach(function(cb) {
      // Skip models with no products in this collection (unless it is the active one)
      if (cb.disabled && cb.value !== activeFilter) return;
      var g = groupOf(cb.value);
      (buckets[g] = buckets[g] || []).push(cb.value);
    });

    var select = document.createElement('select');
    select.className = 'ht-filter-select';
    select.setAttribute('aria-label', 'Device model');

    var defaultOpt = document.createElement('option');
    defaultOpt.value = '';
    defaultOpt.textContent = 'All models';
    select.appendChild(defaultOpt);

    var hasSelected = false;
    GROUPS.forEach(function(grp) {
      var vals = buckets[grp.key];
      if (!vals || !vals.length) return;
      vals.sort(function(a, b) { return rankOf(b) - rankOf(a); });
      var og = document.createElement('optgroup');
      og.label = grp.label;
      vals.forEach(function(val) {
        var opt = document.createElement('option');
        opt.value = val;
        opt.textContent = labelOf(val);
        if (activeFilter && val === activeFilter) {
          opt.selected = true;
          hasSelected = true;
        }
        og.appendChild(opt);
      });
      select.appendChild(og);
    });

    if (hasSelected) select.classList.add('ht-has-value');
    else select.selectedIndex = 0;

    select.addEventListener('change', function() {
      var val = this.value;
      this.classList.toggle('ht-has-value', !!val);
      var params = new URLSearchParams();
      var currentParams = new URLSearchParams(window.location.search);
      if (currentParams.get('sort_by')) {
        params.set('sort_by', currentParams.get('sort_by'));
      }
      if (val) {
        params.set(SIZE_PARAM, val);
      }
      var newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
      window.location.href = newUrl;
    });

    var wrapper = document.createElement('div');
    wrapper.className = 'ht-filter-dropdown-row';

    var lbl = document.createElement('span');
    lbl.className = 'ht-filter-dropdown-label';
    lbl.textContent = 'Device Model';

    wrapper.appendChild(lbl);
    wrapper.appendChild(select);

    deviceDetail.style.display = 'none';

    var insertBefore = filterForm.querySelector('.mobile-facets__details, .mobile-facets__wrapper > *');
    if (insertBefore) {
      insertBefore.parentNode.insertBefore(wrapper, insertBefore);
    } else {
      filterForm.appendChild(wrapper);
    }
  }

  // Desktop and mobile checkbox lists: "13″" reads "Laptop sleeve 13″"
  function relabelSleeves() {
    document.querySelectorAll('input[type="checkbox"][name="' + SIZE_PARAM + '"]').forEach(function(cb) {
      if (groupOf(cb.value) !== 'sleeve') return;
      var label = cb.closest('label') || document.querySelector('label[for="' + cb.id + '"]');
      if (!label || label.dataset.hzRelabelled) return;
      var walker = document.createTreeWalker(label, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        var t = node.nodeValue;
        var idx = t.indexOf(cb.value);
        if (idx !== -1 && !node.parentNode.closest('.visually-hidden')) {
          node.nodeValue = t.slice(0, idx) + 'Laptop sleeve ' + t.slice(idx);
          label.dataset.hzRelabelled = '1';
          break;
        }
      }
    });
  }

  var relabelQueued = false;
  function queueRelabel() {
    if (relabelQueued) return;
    relabelQueued = true;
    setTimeout(function() { relabelQueued = false; relabelSleeves(); }, 80);
  }

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (!node.querySelector) return;
        if (node.id === 'FacetFiltersFormMobile' ||
            node.querySelector && node.querySelector('#FacetFiltersFormMobile')) {
          setTimeout(buildDeviceDropdown, 150);
        }
        if (node.querySelector('input[name="' + SIZE_PARAM + '"]')) queueRelabel();
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('click', function(e) {
    if (e.target.closest('.mobile-facets__open, .facets__open, [data-target="FacetFiltersFormMobile"], .facets-container-drawer')) {
      setTimeout(buildDeviceDropdown, 300);
      setTimeout(buildDeviceDropdown, 700);
    }
  });

  function init() {
    buildDeviceDropdown();
    relabelSleeves();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

/* ============================================
   IDENTITY PILLS: tap and go to results
   - Filter headings open and close reliably (one handler only)
   - Profession and Lifestyle always visible and tappable
   - One identity at a time: a new tap replaces the old one
   - Panel closes by itself once the results are ready
   - Bottom button shows the live count: "Show 14 results"
   - "Life Style" heading reads "Lifestyle"
============================================ */
(function() {
  'use strict';
  var IDENTITY = /^filter\.p\.m\.custom\.(profession|life_style)$/;
  var queued = false;

  function form() { return document.getElementById('FacetFiltersFormMobile'); }

  function countText() {
    var f = form();
    var c = f && f.querySelector('.mobile-facets__count');
    return c ? c.textContent.trim() : '';
  }

  // Filter headings: handle the tap here, before older handlers.
  // After Shopify reloads the filters, two handlers could fire and
  // open then instantly close the group, so only this one runs.
  document.addEventListener('click', function(e) {
    var s = e.target.closest && e.target.closest('#FacetFiltersFormMobile details.mobile-facets__details > summary');
    if (!s) return;
    e.preventDefault();
    e.stopPropagation();
    var d = s.parentNode;
    if (d.hasAttribute('open')) {
      d.removeAttribute('open');
      s.setAttribute('aria-expanded', 'false');
    } else {
      d.setAttribute('open', '');
      s.setAttribute('aria-expanded', 'true');
    }
  }, true);

  function closePanel() {
    var disclosure = document.querySelector('.mobile-facets__disclosure');
    if (!disclosure || !disclosure.hasAttribute('open')) return;
    var summary = disclosure.querySelector(':scope > summary');
    if (summary) summary.click();
    // Safety net if the close animation is interrupted
    setTimeout(function() {
      if (disclosure.hasAttribute('open')) {
        disclosure.removeAttribute('open');
        disclosure.classList.remove('menu-opening');
        document.body.classList.remove('overflow-hidden-mobile');
      }
    }, 900);
  }

  // Close once Shopify has loaded the new results (or after 3s at most)
  function closeWhenReady(before) {
    var waited = 0;
    (function check() {
      if (countText() !== before || waited >= 3000) {
        setTimeout(closePanel, 150);
        return;
      }
      waited += 150;
      setTimeout(check, 150);
    })();
  }

  document.addEventListener('change', function(e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('#FacetFiltersFormMobile input[type="checkbox"]')) return;
    if (!IDENTITY.test(t.name)) return;
    var before = countText();
    if (t.checked) {
      form().querySelectorAll('input[type="checkbox"]').forEach(function(i) {
        if (i !== t && i.checked && IDENTITY.test(i.name)) i.checked = false;
      });
    }
    closeWhenReady(before);
  }, true);

  function htTidy() {
    queued = false;
    var f = form();
    if (!f) return;

    // Identity pills stay tappable even when the other group is selected
    f.querySelectorAll('input[type="checkbox"]:disabled').forEach(function(i) {
      if (!IDENTITY.test(i.name)) return;
      i.disabled = false;
      var l = i.closest('label');
      if (l) l.classList.remove('disabled');
    });

    f.querySelectorAll('.mobile-facets__summary span, .mobile-facets__close-button span').forEach(function(s) {
      if (s.children.length === 0 && s.textContent.trim() === 'Life Style') s.textContent = 'Lifestyle';
    });

    var btn = f.querySelector('.mobile-facets__footer .button');
    var m = countText().match(/(\d+)\s+of/) || countText().match(/(\d+)/);
    if (!btn || !m) return;
    var n = parseInt(m[1], 10);
    var label = n === 0 ? 'No matches' : (n === 1 ? 'Show 1 result' : 'Show ' + n + ' results');
    if (btn.textContent.trim() !== label) btn.textContent = label;
  }

  function queue() {
    if (queued) return;
    queued = true;
    setTimeout(htTidy, 60);
  }

  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', htTidy);
  } else {
    htTidy();
  }
})();
